import { makeStyles } from "@material-ui/styles";

const matchSettingsStyles = makeStyles((theme) => ({
	settings: {
		fontStyle: "italic",
		paddingBottom: theme.spacing(1)
	},
	settingValue: { fontWeight: "bold" }
}));

export default matchSettingsStyles;
